<template>
  <router-link
    class="application-card"
    :to="{ name: 'application-create', params: { id: application.program_id }, query: { app_id: application.id, user_id: application.user_id } }"
  >
    <div class="application-card__top">
      <img :src="application.program_logo" alt="Program Logo" class="program-logo"/>

      <div class="program-info">
        <div class="label">Program:</div>
        <div class="value">{{ application.program }}</div>
      </div>

      <div class="status-info">
        <div class="label">Status:</div>
        <div class="value">{{ application.status }}</div>
      </div>
    </div>

    <div class="application-card__bottom">
      <div class="step-progress-info">
        <div class="label">Last Step Completed: {{ application.last_step_number }}/{{ application.last_step_count }}</div>
        <div class="value">{{ application.last_step_name }}</div>
      </div>

      <div class="session-info">
        <div class="label">{{ sessionSemester }} Dates:</div>
        <div class="value">
          <template v-if="application.sessions.length">
          <span v-for="session in application.sessions" :key="session.id">
            {{ session.start_date }} - {{ session.end_date }}
            <br>
          </span>
          </template>
          <span v-else>{{ sessionSemester }} is not selected</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>

import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'

export default {
  props: {
    application: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [instanceSessionCamperNames],
}
</script>

<style scoped lang="scss">

</style>